import { ChevronDown, ChevronUp } from 'lucide-react'
import { useState } from 'react'
import { Badge, Card, Col, Collapse, Modal, Row } from 'react-bootstrap'

export function ModalReplicarResults({ isOpen, onClose, results }) {
  const [expandedItems, setExpandedItems] = useState({})
  const [expandedSuccessItems, setExpandedSuccessItems] = useState({})

  const itemsSucceedCount = Object.values(results?.success || {}).reduce(
    (acc, item) => {
      acc = acc + item.length
      return acc
    },
    0,
  )

  const itemsFailedCount = Object.values(results?.error || {}).reduce(
    (acc, item) => {
      acc = acc + item.length
      return acc
    },
    0,
  )

  const toggleItem = (index) => {
    setExpandedItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }))
  }

  const toggleSuccessItem = (index) => {
    setExpandedSuccessItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }))
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      size="lg"
      className="modal-modern"
    >
      <Modal.Header
        closeButton
        className="border-0 pb-0"
      >
        <Modal.Title className="fw-bold">Resultado da Replicação</Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4 py-4">
        <Row className="g-4">
          <Col md={6}>
            <Card className="border-0 shadow-sm bg-success bg-opacity-10">
              <Card.Body>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h5 className="mb-0 text-success fw-semibold">
                    <i className="bi bi-check-circle-fill me-2"></i>
                    Sucesso
                  </h5>
                  <Badge
                    bg="success"
                    pill
                    className="px-3 py-2"
                  >
                    {itemsSucceedCount}
                  </Badge>
                </div>

                {itemsSucceedCount > 0 ? (
                  <div className="mt-3">
                    {Object.entries(results?.success).map(
                      ([key, messages], index) => (
                        <Card
                          key={index}
                          className="mb-2 border border-success border-opacity-25"
                        >
                          <Card.Header
                            className="bg-white border-0 py-2 cursor-pointer"
                            onClick={() => toggleSuccessItem(index)}
                            style={{ cursor: 'pointer' }}
                          >
                            <div className="d-flex align-items-center justify-content-between">
                              <Badge
                                bg="success"
                                className="px-2 py-1"
                              >
                                {key}
                              </Badge>
                              {expandedSuccessItems[index] ? (
                                <ChevronUp
                                  size={18}
                                  className="text-success"
                                />
                              ) : (
                                <ChevronDown
                                  size={18}
                                  className="text-success"
                                />
                              )}
                            </div>
                          </Card.Header>
                          <Collapse in={expandedSuccessItems[index]}>
                            <Card.Body className="pt-2 pb-3">
                              <ul className="mb-0 ps-3 text-success small">
                                {messages.map((message, msgIndex) => (
                                  <li
                                    key={msgIndex}
                                    className="mb-1"
                                  >
                                    {message}
                                  </li>
                                ))}
                              </ul>
                            </Card.Body>
                          </Collapse>
                        </Card>
                      ),
                    )}
                  </div>
                ) : (
                  <div className="text-success small opacity-75">
                    Nenhum sucesso registrado
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>

          <Col md={6}>
            <Card className="border-0 shadow-sm bg-danger bg-opacity-10">
              <Card.Body>
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h5 className="mb-0 text-danger fw-semibold">
                    <i className="bi bi-x-circle-fill me-2"></i>
                    Falhas
                  </h5>
                  <Badge
                    bg="danger"
                    pill
                    className="px-3 py-2"
                  >
                    {itemsFailedCount}
                  </Badge>
                </div>

                {itemsFailedCount > 0 ? (
                  <div className="mt-3">
                    {Object.entries(results?.error).map(
                      ([key, messages], index) => (
                        <Card
                          key={index}
                          className="mb-2 border border-danger border-opacity-25"
                        >
                          <Card.Header
                            className="bg-white border-0 py-2 cursor-pointer"
                            onClick={() => toggleItem(index)}
                            style={{ cursor: 'pointer' }}
                          >
                            <div className="d-flex align-items-center justify-content-between">
                              <Badge
                                bg="danger"
                                className="px-2 py-1"
                              >
                                {`${key} (${messages.length})`}
                              </Badge>
                              {expandedItems[index] ? (
                                <ChevronUp
                                  size={18}
                                  className="text-danger"
                                />
                              ) : (
                                <ChevronDown
                                  size={18}
                                  className="text-danger"
                                />
                              )}
                            </div>
                          </Card.Header>
                          <Collapse in={expandedItems[index]}>
                            <Card.Body className="pt-2 pb-3">
                              <ul className="mb-0 ps-3 text-danger small">
                                {messages.map((message, msgIndex) => (
                                  <li
                                    key={msgIndex}
                                    className="mb-1"
                                  >
                                    {message}
                                  </li>
                                ))}
                              </ul>
                            </Card.Body>
                          </Collapse>
                        </Card>
                      ),
                    )}
                  </div>
                ) : (
                  <div className="text-danger small opacity-75">
                    Nenhuma falha registrada
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0">
        <button
          className="btn btn-secondary px-4"
          onClick={onClose}
        >
          Fechar
        </button>
      </Modal.Footer>
    </Modal>
  )
}
